/**
 * AiAutofillBadge — Badge runtime (FASE 4.2.11.8) per campi compilati da OCR AI.
 *
 * Compliance art. 50 AI Act + §8 della pagina /legal/uso-intelligenza-artificiale.
 *
 * Usage:
 *   <AiAutofillBadge visible={isAutofilled(field)} model="claude-haiku-4.5" />
 *
 * Quando visible=true mostra inline un piccolo banner ambra con tooltip.
 */
import { useState } from "react";
import { Sparkles, Info } from "lucide-react";
import { Link } from "react-router-dom";

export default function AiAutofillBadge({
  visible = false,
  model = "claude-haiku-4.5",
  className = "",
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  if (!visible) return null;
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-900 text-[11px] leading-tight mb-1 ${className}`}
      data-testid="ai-autofill-badge"
      role="status"
      aria-label="Campo compilato automaticamente da intelligenza artificiale"
    >
      <Sparkles className="w-3 h-3 shrink-0" aria-hidden="true" />
      <span className="font-medium">🤖 Compilato con AI · Verifica i dati estratti</span>
      <button
        type="button"
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
        onFocus={() => setTooltipOpen(true)}
        onBlur={() => setTooltipOpen(false)}
        onClick={(e) => { e.preventDefault(); setTooltipOpen(v => !v); }}
        className="relative inline-flex items-center justify-center w-3.5 h-3.5 rounded-full hover:bg-amber-100"
        aria-label="Maggiori informazioni sul sistema AI utilizzato"
        data-testid="ai-autofill-info-btn"
      >
        <Info className="w-3 h-3" />
        {tooltipOpen && (
          <span
            className="absolute z-50 top-5 left-1/2 -translate-x-1/2 min-w-[220px] bg-zinc-900 text-white text-[10px] leading-snug rounded-lg px-3 py-2 shadow-xl text-left"
            role="tooltip"
            data-testid="ai-autofill-tooltip"
          >
            <div className="font-semibold mb-1">Sistema AI utilizzato</div>
            <div>Modello: <strong>{model}</strong> (Anthropic via Emergent)</div>
            <div className="mt-0.5">Finalità: estrazione dati documento</div>
            <Link
              to="/legal/uso-intelligenza-artificiale#sezione-2"
              className="block mt-1.5 text-amber-300 underline hover:text-amber-200"
            >
              Maggiori informazioni →
            </Link>
          </span>
        )}
      </button>
    </div>
  );
}
